export const INTERCOM_EVENTS = {
	addLocation: 'add-location',
	avatar: 'avatar',
	customers: 'customers',
	sendReport: 'send-report',
	dryCleaning: 'dry-cleaning',
	gtmSettings: 'gtm-settings',
	laundromatDropdown: 'laundromat-dropdown',
	laundryServices: 'laundry-services',
	location3DotMenu: 'location-3-dot-menu',
	locationsDetails: 'locations-details',
	machineWizard: 'machine-wizard',
	products: 'products',
	promotions: 'promotions',
	settings: 'settings',
	signIn: 'sign-in',
	orders: 'orders',
	tasks: 'tasks',
	team: 'team',
	pricingTiers: 'pricing-tiers',
	onboarding: {
		deliverySettings: 'onboarding-delivery-settings',
		payments: 'onboarding-payments',
		productsAndServices: 'onboarding-products-and-services',
		callCenter: 'onboarding-call-center',
		assistSettings: 'onboarding-assist-settings',
	},
} as const;

export const INTERCOM_EVENTS_TEMPLATES = {
	addNewLocation: 'Pushed {{Button Name}} Button to add new location',
	tasksAction: '{{Task Action}} {{Task Name}} Task',
	avatar: 'Avatar',
	sendReport: 'Send Report',
	trackLocationForm: 'Pushed {{Button Name}} Button on {{Wizard Step}} wizard screen',
	machineWizard: {
		wizardStepButton: `"{{buttonName}}" button {{wizardStep}} wizard page`,
		washerDryer: 'Washer/Dryer',
		addingNew: 'Adding New Machine',
	},
	laundromatLocationsDropdown: 'Laundromats: locations have been changed',
	laundryServices: {
		buttonAdd: 'Adding New Laundry Service',
		buttonArchive: 'Archive Service',
		wizardButton: 'Add Service Wizard "{{buttonName}}" button page {{wizardStep}}',
	},
	settings: 'Settings',
	signIn: 'User login',
	location3DotMenu: {
		configurePaymentOptions: 'Configure Payment Options',
		checkedInEmployees: 'Checked in employees',
		storeClosures: 'Store Closures',
	},
	team: {
		addNewTeamMember: 'Team member {{First name}} {{Last name}} has been added',
		enableManager: 'Manager role for {{Full name}} has been enabled',
		enableAdminAccess: 'Admin access was provided to {{Full name}}',
		timeCardEdit: 'Time card has been edited',
		timeCardAdd: 'Time card has been added',
	},
	customers: {
		toggleCommercialCustomer: 'Commercial customer has been {{Commercial status}}',
		adjustCredit: 'Credit has been adjusted',
		removeCardOnFile: 'Card on file was deleted',
		createNewOrderForCustomer: 'Creating new order for customer',
	},
	dryCleaning: {
		addNewService: 'Adding new dry cleaning service',
		archiveService: 'Archive service',
	},
	gtmSettings: {
		updateGtmSettings: 'Updating GTM settings',
		removeGtmSettings: 'Removing GTM settings',
		promptRemoveGtmSettings: 'Prompting GTM settings removal',
	},
	orders: {
		voidOrder: 'Void Order',
		manageOrder: 'Manage Order',
		orderOnBehalfOf: 'Order on behalf of',
	},
	promotion: {
		addNew: 'Add new promotion',
		activate: 'Activate existing promotion',
		deactivate: 'Deactivate promotion',
	},
	products: {
		add: 'Add new Product',
		archive: 'Archive Product',
	},
	locationsDetails: {
		processingSettings: '{{Option}} Processing',
	},
	pricingTiers: {
		addNewPricing: 'Add new {{Type}} Pricing',
		deliveryTab: 'Delivery Tab - {{Delivery Type}}',
	},
	onboarding: {
		deliverySettings: 'Clicked on delivery settings',
		payments: 'Clicked on payments',
		productsAndServices: 'Clicked on products and services',
		callCenter: 'Clicked on call center',
		assistSettings: 'Clicked on assist settings',
	},
} as const;

export const DEFAULT_INTERCOM_VALUES = {
	NO_RECORD: 'no record',
};
